// extracted by mini-css-extract-plugin
export default {"containerDetalle":"Detail_containerDetalle__IeS62","detalleCard":"Detail_detalleCard__Xpx9d","imgDetalle":"Detail_imgDetalle__SOUyt","btnDetalle":"Detail_btnDetalle__cKa0Y"};